// extracted by mini-css-extract-plugin
module.exports = {"item":"post-link-module--item--3Tuvk","image":"post-link-module--image--1O2Qz","title":"post-link-module--title--2EEO9","date":"post-link-module--date--2nADx"};